import React from 'react'

import { FairUse } from 'src/styled'
import { LEGACY_SITE_URL } from 'src/app/api'
import { Text } from '@sendoutcards/quantum-design-ui'

interface Props {
  messages: string[]
}

const Disclaimer: React.FC<Props> = props => {
  const { messages } = props
  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      {messages &&
        messages.map((message, index) => (
          <Text key={index} type="footnote">
            {message}
          </Text>
        ))}
      <Text type="footnote">
        All Heartfelt Prompting Cards are subject to the {''}
        <FairUse
          target="blank"
          href={`${LEGACY_SITE_URL}/resources/documents/393/Fair_Use_Policy_July_1_2020.pdf`}
          onClick={e => e.stopPropagation()}
        >
          <Text type="footnote" color="primaryBrand">
            Fair Use Policy
          </Text>
        </FairUse>{' '}
        and all prices are in USD.
      </Text>
    </div>
  )
}

export default Disclaimer
